import classNames from 'classnames';
import { getCdnUrl } from '@/utils/url';
import { ColorType } from '../product-card/types';
interface Props {
  color: ColorType;
  selectedVariantId?: string;
  notSaleable?: boolean;
  onClick?: (id: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  className?: string;
}
const UnknownVariant = getCdnUrl('/_toad/images/unknown-variant.svg');
const ColorVariant = ({
  color,
  selectedVariantId,
  notSaleable = false,
  onClick,
  handleMouseEnter,
  handleMouseLeave,
  className
}: Props) => {
  const onImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.currentTarget;
    target.onerror = null;
    target.src = UnknownVariant;
    const parent = target.parentNode as HTMLPictureElement | null;
    if (parent) {
      const children = Array.from(parent.children);
      children.forEach(child => {
        if (child instanceof HTMLSourceElement) {
          child.srcset = target.src;
        }
      });
    }
  };
  const variantContentClassName = classNames('h-9 w-9 rounded box-border border', {
    'border-gray-50 outline outline-1 outline-outline-gray-medium': !notSaleable && color.id !== selectedVariantId,
    'border-gray-50 outline outline-2 outline-gray-900': color.id === selectedVariantId,
    'border-gray-900': notSaleable && color.id !== selectedVariantId
  });
  return <button aria-label={color.name || ''} type='button' className={classNames('relative p-1', {
    'after:absolute after:right-0 after:top-1/2 after:h-px after:w-full after:-rotate-45 after:bg-neutral-800 after:content-[""]': notSaleable
  }, className)} onClick={e => onClick && onClick(color.id, e)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-sentry-component="ColorVariant" data-sentry-source-file="color-variant.tsx">
            {color.hex ? <div className={variantContentClassName} style={{
      backgroundColor: color.hex
    }} /> : <img src={`${color?.image}?w=38` || UnknownVariant} alt={color.name} width={32} height={32} className={variantContentClassName} onError={onImageError} />}
        </button>;
};
export default ColorVariant;